import {
  EXPAND_IS_LOADING_MORE_MEDIAS,
  EXPAND_ON_ADD_MEDIAS,
  MAX_COUNT_FEED,
  MAX_COUNT_HASHTAG,
} from '../../constants';
import { createHeaders } from '../more/utils';
import { getInstagramMediasData } from '../services/instagramUserAndMediasService';
import { getHashtagMediaApi } from '../api/hashtagApi';
import { orderHashtags } from '../services/hashtagService';

/**
 * Check if need to load more medias
 * @param {Function} dispatch
 * @param {Number} newIndex -index of current display media
 * @param {Object} pagination - pagination of medias
 * @param {Array} medias - medias (feed / hashtags)
 * @param {Boolean} isLodingMedias
 * @param {String} accessToken
 * @param {Number} userId
 * @param {Boolean} isHashtagMedias
 * @param {Boolean} isBusinessApp
 * @param {Boolean} isRecent
 */
export const loadMoreMedias = (
  dispatch,
  newIndex,
  pagination,
  medias,
  isLodingMedias,
  accessToken,
  userId,
  isHashtagMedias,
  isBusinessApp,
  isRecent,
) => {
  let hashtagsHaveMoreMedias;

  if (isHashtagMedias) {
    hashtagsHaveMoreMedias = pagination.filter((hashtag) => {
      return hashtag && hashtag.pagination && hashtag.pagination.after;
    });
  }

  const from = isHashtagMedias
    ? hashtagsHaveMoreMedias.length
    : pagination.after || pagination.next_max_id;

  // check if need to fetch more medias.
  if (newIndex >= medias.length - 10 && from && !isLodingMedias) {
    isHashtagMedias
      ? _loadMoreHashtagMedias(
          dispatch,
          accessToken,
          userId,
          isRecent,
          hashtagsHaveMoreMedias,
        )
      : _loadMoreFeedMedias(dispatch, accessToken, userId, isBusinessApp, from);
  }
};

/**
 * load more feed images
 * @param {Function} dispatch - to update data
 * @param {String} accessToken -token of user
 * @param {Number} userId - id of user
 * @param {Boolean} isBusinessApp
 * @param {String} from - pagination
 */
const _loadMoreFeedMedias = (
  dispatch,
  accessToken,
  userId,
  isBusinessApp,
  from,
) => {
  dispatch({
    type: EXPAND_IS_LOADING_MORE_MEDIAS,
    payload: true,
  });

  return getInstagramMediasData(from, MAX_COUNT_FEED).then(
    ({ medias, pagination }) => {
      dispatch({
        type: EXPAND_ON_ADD_MEDIAS,
        payload: {
          medias,
          pagination,
        },
      });
    },
  );
};

/**
 *
 * @param {*} dispatch
 * @param {*} accessToken
 * @param {*} userId
 * @param {*} isRecent
 * @param {*} hashtags
 */
const _loadMoreHashtagMedias = (
  dispatch,
  accessToken,
  userId,
  isRecent,
  hashtags,
) => {
  dispatch({
    type: EXPAND_IS_LOADING_MORE_MEDIAS,
    payload: true,
  });

  const count = Math.ceil(MAX_COUNT_HASHTAG / hashtags.length);

  const arr = hashtags.map(({ hashtagId, pagination }) => {
    return getHashtagMediaApi(
      hashtagId,
      count,
      pagination.after,
      isRecent,
      createHeaders(accessToken, userId, true),
    );
  });

  Promise.all(arr).then((res) => {
    let newHashtags = [];
    res.map(({ items, pagination }, index) => {
      if (items) {
        newHashtags = newHashtags.concat(items);
        hashtags[index] = {
          ...hashtags[index],
          items: hashtags[index].items.concat(items),
          pagination,
        };
      }
    });

    const data = orderHashtags([], newHashtags, isRecent);

    dispatch({
      type: EXPAND_ON_ADD_MEDIAS,
      payload: {
        medias: data,
        pagination: hashtags,
      },
    });
  });
};
